/**
 * 412 (#1505, mock-up frame 4): a plain sentence beside a catalogue row, for rows whose action name alone does not say
 * what it grants. The Penalty rows have one (their two money powers are the point of the split), and the reserved
 * Cartrack rows: 419's immobiliser and 420's door lock.
 */
const HINTS: Record<string, Record<string, string>> = {
  Penalty: {
    manage: 'everything below',
    read: 'see penalties and their dashboard',
    create: 'record a penalty',
    update: 'edit or cancel a penalty',
    'confirm-payment': 'confirm the customer paid: mark paid, approve or reject a receipt',
    payout: 'pay out to the host',
  },
  // 419 (#1529): reserved, granted to no role.
  CarImmobiliser: {
    immobilise: 'immobilise or release a car through Cartrack (only a SuperAdmin by default)',
  },
  // 420: reserved too, and separate from the immobiliser.
  CarDoorLock: {
    lock: "lock or unlock a car's doors through Cartrack (only a SuperAdmin by default)",
  },
  // 421 (#1528): reserved; also decides 410's past cancel.
  PastBooking: {
    change:
      'extend a rental after its return time, settle its QR payment, and cancel a past booking (only a SuperAdmin by default)',
  },
};

export function permissionHint(subject: string, action: string): string | null {
  return HINTS[subject]?.[action] ?? null;
}
